import { ReactElement } from 'react';

export const VideoIcon = ({
	className = '',
	onClick,
	disabled,
	fill,
}: {
	className: string;
	onClick: VoidFunction;
	disabled: boolean;
	fill?: string;
}): ReactElement => {
	return (
		<svg
			className={className}
			onClick={disabled ? (): void => void 0 : onClick}
			style={{ opacity: disabled ? '0.7' : '1' }}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.4176 18L5.62344 18C4.18893 18 3.0205 16.7884 3.0205 15.2983V8.70173C3.0205 7.21158 4.18893 6 5.62344 6L14.4176 6C15.8521 6 17.0205 7.21158 17.0205 8.70173V15.2983C17.0205 16.7884 15.8521 18 14.4176 18ZM5.87314 7.98741C5.39535 7.98741 5.00549 8.39087 5.00549 8.88799V15.108C5.00549 15.6051 5.39535 16.0085 5.87314 16.0085L14.1851 16.0085C14.6629 16.0085 15.0527 15.6051 15.0527 15.108V8.88799C15.0527 8.39087 14.6629 7.98741 14.1851 7.98741L5.87314 7.98741Z"
				fill={fill}
			/>
			<path
				d="M20.4464 17.0039C20.1549 17.0039 19.8609 16.927 19.6038 16.7733L15.6928 14.3061C15.2448 14.0376 15.1099 13.4727 15.3899 13.0444C15.6686 12.6161 16.2567 12.4855 16.7047 12.7527L19.9961 14.9353V9.08691L16.7047 11.2556C16.2554 11.5228 15.6686 11.3922 15.3899 10.9639C15.1099 10.5356 15.246 9.97069 15.6928 9.70224L19.6038 7.23501C20.0964 6.94094 20.7124 6.92752 21.219 7.19474C21.7231 7.46318 22.0374 7.97445 22.0374 8.52841V15.4774C22.0374 16.0314 21.7231 16.5439 21.2177 16.8123C20.9785 16.9405 20.7124 17.0039 20.4464 17.0039Z"
				fill={fill}
			/>
		</svg>
	);
};
